// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__1FmOC","footer":"ChangeClinic_footer__3Pk_A"};